<template>
  <div>
    <!-- 表格列表区域 -->
    <el-card class="table-card">
      <el-form :model="searchForm" inline label-width="120px">
        <el-form-item label="关键词" prop="keyword">
          <el-input v-model="searchForm.keyword" placeholder="请输入国家名称/编码/大洲/运营商/运营商编码"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="searchForm.status" placeholder="请选择状态">
            <el-option label="启用" value="1"></el-option>
            <el-option label="停用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button type="primary" @click="handleReset">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openSelector">添加</el-button>
        </el-form-item>
      </el-form>  
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="tableLoading"
      >
        <!-- 表格列定义 -->
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column prop="countryName" label="国家名称" align="center"  :show-overflow-tooltip="true" ></el-table-column>
        <el-table-column prop="countryNameTc" label="英文名称" align="center" :show-overflow-tooltip="true"  ></el-table-column>
        <el-table-column prop="countryCode" label="国家编码" align="center"></el-table-column>
        <el-table-column prop="continent" label="大洲" align="center"></el-table-column>
        <el-table-column prop="operator" label="运营商名称" align="center" :show-overflow-tooltip="true" ></el-table-column>
        <el-table-column prop="mccMnc" label="MccNnc" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == '1' ? 'success' : 'danger'">{{ scope.row.status == '1' ? '启用' : '停用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
            <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
            </template>
        </el-table-column>
      </el-table>
      <!-- 分页控件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        />
      </div>
    </el-card>
    <!-- 添加国家运营商选择弹窗 -->
    <CountryOperatorSelector 
      ref="selectorRef" 
      @select-complete="handleSelectComplete"
    />
  </div>
</template>

<script>
import { internationalChnanelOperatorPage , internationalChnanelOperatorSave , internationalChnanelOperatorDel} from '@/api/international'
import CountryOperatorSelector from './CountryOperatorSelector.vue'
export default {
  data() {
    return {
      // 表格相关数据
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      searchForm: {
        channel:this.channel,
        keyword: '',
        status: ''
      },
      // Tab相关数据
      activeTab: 'basic',
      // 表单数据
      basicForm: {
        name: '',
        type: ''
      },
      advancedForm: {},
      // 统计数据
      statisticData: [],
    }
  },
  components: { CountryOperatorSelector },
  props: {
    channel: {
      type: String,
      required: true,
    }
  },
  mounted() {
    // 页面加载时获取表格数据
    this.loadTableData()
  },
  methods: {
    // 加载表格数据
    loadTableData() {
      this.tableLoading = true
      internationalChnanelOperatorPage({
        page: this.currentPage,
        pageSize: this.pageSize,
        model: this.searchForm
      }).then(res => {
        this.tableData = res.data.data.records
        this.totalCount = res.data.data.total
        this.tableLoading = false
      })
    },
    
    // 分页相关方法
    handleSizeChange(val) {
      this.pageSize = val
      this.loadTableData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadTableData()
    },
    handleSearch() {
      this.loadTableData()
    },
    handleReset() {
      this.searchForm = {
        channel:this.channel,
        keyword: '',
        status: ''
      }
      this.loadTableData()
    },
    handleAdd() {
      this.dialogVisible = true
      this.activeTab = 'basic'
      this.basicForm = {
        name: '',
        type: ''
      }
      this.advancedForm = {}
    },
    // 删除操作
    handleDelete(row) {
      // 删除逻辑
      let id = row.id
      this.$confirm("此操作将删除此卡源运营商, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
			}).then(() => {
        internationalChnanelOperatorDel({id}).then(res=>{
          this.$notify({
            title: '成功',
            message: '卡源运营商删除成功',
            type: 'success'
          });
          this.loadTableData();
        })
      })

    },
    openSelector() {
      // 无回显打开
      this.$refs.selectorRef.openDialog()
    },
    // 接收选中结果
    handleSelectComplete(result) {
      internationalChnanelOperatorSave({
        channel:this.channel,
        mccMnc: result
      }).then(res=>{
        this.$notify({
          title: '成功',
          message: '卡源运营商保存成功',
          type: 'success'
        });
        this.loadTableData()
      })

    }
  }
}
</script>

<style scoped lang="less">

.pagination-container {
  margin-top: 15px;
  text-align: right;
}

.tab-card {
  padding: 15px;
}

.tab-content {
  padding: 20px 0;
}

</style>
